export default __webpack_public_path__ + "static/media/ill-error.df884b01.png";